import React from 'react';
import PropTypes from 'prop-types';

import PageHeader from '../../atoms/PageHeader';
import ConnectorEditor from '../../components/ConnectorEditor';
import Loading from '../../components/Loading';

const NewConnector = ({ history, match, loading }) => {
  if (loading) {
    return <Loading />;
  }
  return (
    <>
      <PageHeader>
        <h4>New Connection</h4>
      </PageHeader>
      <ConnectorEditor history={history} match={match} />
    </>
  );
};

NewConnector.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired
};

export default NewConnector;
